class ProductQuantitySelectorBlocks extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll(".quantity-selector-blocks__item");
    this.onItemClick = this.onItemClick.bind(this);
  }

  connectedCallback() {
    this.items.forEach(item => {
      item.addEventListener("click", this.onItemClick);
    });

    document.addEventListener(_EVENT_HELPER.onQuantityChange, (event) => {
      const { quantity } = event.detail;
      this.updateSelectedBlockByQuantity(quantity);
    });
  }

  updateSelectedBlockByQuantity(quantity) {
    let matched = false;
    this.items.forEach((item) => {
      const blockQuantity = Number(item.dataset.quantity);
      if (blockQuantity === Number(quantity)) {
        item.classList.add('selected');
        matched = true;
      } else {
        item.classList.remove('selected');
      }
    });

    if (!matched) {
      this.items.forEach(item => item.classList.remove('selected'));
    }
  }

  onItemClick(e) {
    this.items.forEach(item => item.classList.remove("selected"));
    e.currentTarget.classList.add("selected");
    const quantity = e.currentTarget.dataset.quantity;
    const quantityInput = document.querySelector('.main-product quantity-selector input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = quantity;
      HELPER_UTIL.dispatchCustomEvent(
        _EVENT_HELPER.onQuantityChange,
        quantityInput,
        {
          quantity: quantity,
        }
      );
    }
  }
}

customElements.get("product-quantity-selector-blocks") ||
customElements.define("product-quantity-selector-blocks", ProductQuantitySelectorBlocks);
